import { render, staticRenderFns } from "./Comparify.vue?vue&type=template&id=600d5f92&"
import script from "./Comparify.vue?vue&type=script&lang=js&"
export * from "./Comparify.vue?vue&type=script&lang=js&"
import style0 from "./Comparify.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports